import { render, staticRenderFns } from "./ListAlerts.vue?vue&type=template&id=1245ebdb&scoped=true&"
import script from "./ListAlerts.vue?vue&type=script&lang=js&"
export * from "./ListAlerts.vue?vue&type=script&lang=js&"
import style0 from "./ListAlerts.vue?vue&type=style&index=0&id=1245ebdb&lang=scss&scoped=true&"
import style1 from "./ListAlerts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245ebdb",
  null
  
)

export default component.exports